import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ValidationMessageComponent } from '../../../../shared/components/validation-message/validation-message.component';
import { EmailVerificationComponent } from '../../../../shared/components/email-verification/email-verification.component';
import { CaptchaComponent } from '../../../../shared/components/captcha/captcha.component';
import { MiddlewareService } from '../../../../core/services/middleware.service';
import { EncryptionService } from '../../../../core/services/encryption.service';
import { CommonService } from '../../../../core/services/common.service';
import { ModalService } from '../../../../core/services/modal.service';
import { EmailVerificationResponse } from '../../../../core/models/email-verification-response.model';
import { ApiResponse } from '../../../../core/enums/api-response.enum';
import { ModalType } from '../../../../core/enums/modal-type.enum';
import { globalDatas } from '../../../../../assets/data/globals';
import { apiURL } from '../../../../../assets/data/api-url';
import { RouteType } from '../../../../core/enums/route-type.enum';
import { mobileIdPathEnum } from '../../../../core/enums/mobileId-path.enum';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MobileAuthInstructionComponent } from '../../../../shared/components/mobile-auth-instruction/mobile-auth-instruction.component';
import { LoaderService } from '../../../../core/services/loader.service';
import { IdNotRegisterdInfoComponent } from '../../../user/profile/add-edit-profile-details/id-not-registerd-info/id-not-registerd-info.component';
import { CivilIdInfoComponent } from "../../../user/profile/civil-id-info/civil-id-info.component";
import { Component_Name } from '../../../../core/enums/component-name.enum';
import { PrivacyPolicyComponent } from '../../../privacy-policy/privacy-policy.component';
import { TermsAndConditionsComponent } from '../../../terms-and-conditions/terms-and-conditions.component';
import { VisaTypes } from '../../../../core/enums/visa-types.enum';

@Component({
  selector: 'app-family-sign-up',
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    ReactiveFormsModule,
    ValidationMessageComponent,
    EmailVerificationComponent,
    TranslateModule,
    CaptchaComponent,
    CivilIdInfoComponent
  ],
  templateUrl: './family-sign-up.component.html',
  styleUrl: './family-sign-up.component.scss'
})
export class FamilySignUpComponent {
  sponsorInfoForm!: FormGroup;
  isSubmitted = false;
  parentComponent = Component_Name.SIGN_UP;
  accountType = VisaTypes.FAMILY;
  showPassword = false;
  signInResponse: any;
  showCaptcha = false;
  showTempSuspendMessage: boolean = false;
  private formSubscription: Subscription | null = null;
  civilIdMaxLimit = globalDatas.CIVIL_ID_MAX_LIMIT;
  civilIDFormat = globalDatas.CIVIL_ID;
  routeType = RouteType;
  mobileAuthTrackId!: string;
  uploadedImage!: string;
  emailControl = new FormControl('', [Validators.required, Validators.email, Validators.pattern(globalDatas.EMAIL_REG_EXP)
  ]);
  civilIdControl = new FormControl('', [Validators.required, Validators.pattern(this.civilIDFormat)
  ]);
  componentsName = Component_Name;

  constructor(
    private router: Router,
    private _fb: FormBuilder,
    private _middlewareService: MiddlewareService,
    private encryptionService: EncryptionService,
    private commonService: CommonService,
    private modalService: ModalService,
    private ngbModal: NgbModal,
    protected translateService: TranslateService,
    private loaderService: LoaderService,
    private translate: TranslateService
  ) {
    this.loadSponsorInfoForm();
  }

  ngOnInit(): void {
    localStorage.removeItem('accty');
    const historyState = (window.history.state || {}) as any;
    if (historyState?.result) {
      this.civilIdControl.setValue(historyState?.result?.response?.civilId);
      this.checkSponsorValidity(historyState?.result?.response);
    }
    this.civilIdControl.valueChanges.subscribe(() => {
      if (this.showTempSuspendMessage) {
        this.showTempSuspendMessage = false;
      }
      if (this.isSubmitted) {
        this.showCaptcha = false;
      }
    })
  }

  ngOnDestroy(): void {
    this.formSubscription?.unsubscribe();
  }

  loadSponsorInfoForm() {
    this.sponsorInfoForm = this._fb.group({
      civilId: [''],
      civilIdExpiry: [''],
      fullnameAr: [''],
      fullnameEn: [''],
      gender: [''],
      passportNationalityAr: [''],
      passportNationality: [''],
      dateOfBirth: [''],
      phoneNumberCountryCode: [
        globalDatas.DEFUALT_MOBILE_COUNTRY_CODE.dialCode,
        [Validators.required],
      ],
      phoneNumberValue: [
        '',
        [
          Validators.required,
          Validators.min(globalDatas.MOBILE_NUMBER_MIN_LIMIT)
        ],
      ],
      phoneNumberCountryISO: [globalDatas.DEFUALT_MOBILE_COUNTRY_CODE.countryCode],
      mobileIdEmail: [''],
      governerate: [''],
      area: [''],
      paciBuildingNumber: [''],
      buildingNumber: [''],
      blockNumber: [''],
      streetNumber: [''],
      preferredLanguage: [
        this.commonService.systemLanguage ?
          this.commonService.systemLanguage : globalDatas.DEFUALT_PREFERRED_LANGUAGE,
        [Validators.required]],
      termsAndCondition: ['', [Validators.required]],
      email: ['', [Validators.required]],
      verificationId: ['']
    });

  }

  onClickSendAuth() {
    this.isSubmitted = true;
    if (this.civilIdControl.valid) {
      this.showCaptcha = true;
      // this.initiateAuth();
    }

  }

  initiateAuth() {
    this.isSubmitted = true;
    if (this.civilIdControl.valid) {
      const encryptedPayload = this.encryptionService.encryptData({
        civilId: this.civilIdControl?.value?.toString(),
        mobileIdPath: mobileIdPathEnum.UPDATE_PROFILE
      });

      this._middlewareService
        .callPostMiddleware(apiURL.mobileIdAuth, { payload: encryptedPayload })
        .subscribe({
          next: (response: any) => {
            if (response?.code === ApiResponse.OK) {
              if (response?.result?.code === ApiResponse.ERROR) {
                this.modalService.commonAlertModal(this.translateService.currentLang === 'ar' ? response?.result?.arabicMessage : response?.result?.message, ModalType.WARNING);
                return;
              }
              if (response?.result?.Result == 'success') {
                this.mobileAuthTrackId = response?.result?.TrackId;
                const modalRef = this.ngbModal.open(MobileAuthInstructionComponent, {
                  centered: true,
                  size: 'lg',
                  backdrop: 'static',
                });
                modalRef.componentInstance.mobileIdAuthPath = 'civilIdSignUp';
                modalRef.componentInstance.mobileAuthTrackId = this.mobileAuthTrackId;
                modalRef.componentInstance.civilId = this.civilIdControl?.value?.toString();
                modalRef.result.then(
                  (result) => {
                    this.loaderService.showLoader.set(false);
                    if (result && result.message === 'success') {
                      if (result?.response?.civilId) {
                        this.checkSponsorValidity(result?.response);
                      }
                    } else if (result === 'User is not eligible') {
                      this.ngbModal.open(IdNotRegisterdInfoComponent, {
                        centered: true,
                        size: 'xl',
                        backdrop: 'static',
                      });
                    }
                  });
              } else if (response?.result?.Result == 'fail') {
                this.isSubmitted = true;
                this.modalService.commonAlertModal("CREATE_VISA.CIVIL_ID_INFO.CIVIL_ID_AUTHENTICATION_REJECTED", ModalType.WARNING);
              } else if (response?.result?.Result == 'User is not eligible') {
                this.isSubmitted = true;
                this.ngbModal.open(IdNotRegisterdInfoComponent, {
                  centered: true,
                  size: 'xl',
                  backdrop: 'static',
                });
              } else {
                this.modalService.commonAlertModal("CREATE_VISA.CIVIL_ID_INFO.CIVIL_ID_NOT_MATCHED", ModalType.WARNING);
              }
            }
          },
          error: (error: any) => {
            error.status == 409 ?
              this.modalService.commonAlertModal("CREATE_VISA.CIVIL_ID_INFO.CIVIL_ID_AUTHENTICATION_CONFLICT", ModalType.WARNING)
              :
              this.modalService.commonAlertModal("ERROR_MESSAGES.DEFUALT_ERROR", ModalType.WARNING);
          },
        });
    }
  }

  checkSponsorValidity(personDetails) {
    const encryptedPayload = this.encryptionService.encryptData({
      CivilId: Number(this.civilIdControl?.value),
    });
    this._middlewareService
      .callPostMiddleware(apiURL.noAuthSponsorValidation, { payload: encryptedPayload })
      .subscribe(
        {
          next: (result) => {
            if (result?.code === ApiResponse.OK) {
              if (result?.result?.eligibility && result?.result?.relationCode?.length) {
                this.patchValuesToSponsorInfoForm({ ...personDetails, civilId: Number(personDetails.civilId), Gender: personDetails?.Gender === 'M' ? 'Male' : 'Female' });
                this.civilIdControl.disable();
                window.scrollTo(0, 0);
              } else if (result?.result?.eligibility === null) {
                if (globalDatas.SPONSOR_VALID_REDIRECT_ERROR_CODE.has(result?.result?.returnCode)) {
                  this.commonService.clearLogInData(true);
                  this.router.navigate([`${this.commonService.getRouteStartIndex()}/contact-us`]);
                }
                this.modalService.commonAlertModal(this.translate.currentLang !== 'ar' ? result?.result?.ReturnMessage : result?.result?.ReturnMessageAr, ModalType.WARNING);
              }
              else {
                this.modalService.commonAlertModal("PROFILE.CIVIL_ID_NOT_ELIGIBLE", ModalType.WARNING);
              }
            }
          },
        });
  }

  patchValuesToSponsorInfoForm(verifiedPersonDetails) {
    let civilIdExpiryFormat = this.formatDateToYYYYMMDD(verifiedPersonDetails?.CardExpiryDate); // DD/MM/YYYY format
    let dateOfBirthFormat = this.formatDateToYYYYMMDD(verifiedPersonDetails?.BirthDate); // DD/MM/YYYY format
    this.sponsorInfoForm.patchValue({
      dateOfBirth: dateOfBirthFormat,
      civilIdExpiry: civilIdExpiryFormat,
      fullnameAr: verifiedPersonDetails?.FullName,
      fullnameEn: verifiedPersonDetails?.FullNameEn,
      gender: verifiedPersonDetails?.Gender,
      passportNationalityAr: verifiedPersonDetails?.Nationality,
      passportNationality: verifiedPersonDetails?.NationalityEn,
      trackId: verifiedPersonDetails?.TrackId,
      civilId: verifiedPersonDetails?.civilId,
      phoneNumberValue: Number(verifiedPersonDetails?.MobileNumber),
      mobileIdEmail: verifiedPersonDetails?.EMail,
      governerate: verifiedPersonDetails?.Governerate,
      area: verifiedPersonDetails?.Area,
      paciBuildingNumber: verifiedPersonDetails?.PaciBuildingNumber,
      buildingNumber: verifiedPersonDetails?.BuildingNumber,
      blockNumber: verifiedPersonDetails?.BlockNumber,
      streetNumber: verifiedPersonDetails?.StreetName,
    });
  }

  formatDateToYYYYMMDD(dateString: string): string {
    if (!dateString) return ''; // Handle empty cases
    let date = new Date(dateString);
    let year = date.getFullYear();
    let month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure two digits
    let day = String(date.getDate()).padStart(2, '0'); // Ensure two digits
    return `${year}-${month}-${day}`;
  }

  onVerifyOTP(emittedData: EmailVerificationResponse) {
    this.sponsorInfoForm.get('email')?.setValue(emittedData?.email);
    this.sponsorInfoForm.get('verificationId')?.setValue(emittedData?.response?.result?.verificationId);

  }

  handleRecaptchaResponse(response: boolean) {
    if (response) {
      this.initiateAuth();
    }
  }

  onClickSignUp() {
    if (this.sponsorInfoForm.valid) {
      const {
        civilId,
        phoneNumberCountryCode,
        phoneNumberValue,
        phoneNumberCountryISO,
        preferredLanguage,
        email,
        fullnameEn,
        verificationId
      } = this.sponsorInfoForm.value;

      const filteredData = {
        civilId: Number(civilId),
        phoneNumberCountryCode,
        phoneNumberValue,
        phoneNumberCountryISO,
        preferredLanguage,
        email,
        givenName: fullnameEn,
        verificationId
      };
      const encryptedPayload = this.encryptionService.encryptData(
        filteredData
      );
      this._middlewareService
        .callPostMiddleware(apiURL.updateFamilySponsorProfile, { payload: encryptedPayload })
        // .callPostMiddleware(apiURL.createSponsorProfile, restWithoutTerms)
        .subscribe(
          (result) => {
            if (result?.code === ApiResponse.OK) {
              this.modalService.commonAlertModal('SIGN_UP.SIGN_UP_SUCCESS_MESSAGE', ModalType.SUCCESS);
              this.router.navigate([this.routeType.FAMILY_SIGN_IN]);
            }
          }
        );
    }
  }

  openModal(name: string) {
    const modalRef = this.ngbModal.open(name === Component_Name.PRIVACY_POLICY ? PrivacyPolicyComponent : TermsAndConditionsComponent, {
      centered: true,
      size: 'lg',
    });
    modalRef.componentInstance.showCloseBtn = true;
  }

  termsAndConditionChange() {
    if (this.sponsorInfoForm.value.termsAndCondition !== true) {
      this.sponsorInfoForm.get('termsAndCondition')?.setValue('');
    }
  }
}
